var _desc, _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGmailBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip494_124"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "mail-send-envelope--envelope-email-message-unopened-sealed-close--Streamline-Core",
    rx: 0,
    width: 19.333527,
    height: 19.333527,
    transform: "translate(0.333237 0.333237)",
    fill: "white",
    fillOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "mail-send-envelope--envelope-email-message-unopened-sealed-close--Streamline-Core",
    rx: 0,
    width: 19.333527,
    height: 19.333527,
    transform: "translate(0.333237 0.333237)",
    fill: "#FFFFFF",
    fillOpacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip494_124)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.61 3C18.37 3 19 3.63 19 4.42L19 16.57C19 17.36 18.37 18 17.61 18L2.38 18C1.62 18 1 17.36 1 16.57L1 4.42C1 3.63 1.62 3 2.38 3L17.61 3Z",
    stroke: "#0000AC",
    strokeOpacity: 1,
    strokeWidth: 1.332948,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.71 4.28L9.08 11.42C9.34 11.64 9.66 11.75 10 11.75C10.33 11.75 10.65 11.64 10.91 11.42L19.28 4.28",
    stroke: "#0000AC",
    strokeOpacity: 1,
    strokeWidth: 1.332948,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmailBlue);
export default __webpack_public_path__ + "static/media/gmail-blue.ecc4c29a13a331dedeb611ae0c259960.svg";
export { ForwardRef as ReactComponent };